import type { ButtonConfig } from '../../declare'
import { useEffect, useRef } from 'react'
import { toJS } from 'mobx'
import { RollbackOutlined, CheckSquareOutlined } from '@ant-design/icons'
import { EasyIcon } from 'src/components'
import { set } from 'lodash'

type Props = {
  config: ButtonConfig
}

const TableRowEdit = (props: Props) => {
  const initRecord = useRef<any>(null)
  useEffect(() => {
    if (props.config.__RECORD__ && !initRecord.current) {
      initRecord.current = toJS(props.config.__RECORD__)
    }
  }, [props.config.__RECORD__])

  const handleEdit = (edit: boolean, save?: boolean) => {
    const { __CONTEXT__: editTable, __RECORD__: record } = props.config
    if (record.IS_DELETED) return

    const copyData = toJS(editTable.activeTableData?.dataSource || [])
    const findIndex = copyData.findIndex((data: any) => data.ID === record.ID)
    if (edit) {
      set(copyData[findIndex], '__EDITABLE__', !save)
    } else {
      copyData.splice(findIndex, 1, initRecord.current)
    }
    editTable.activeTable.setDataSource(copyData)
  }

  const { __RECORD__: record, __READONLY__, LABEL, ICON, } = props.config
  if (__READONLY__) {
    return <span className='color-disabled'>{LABEL}</span>
  }
  if (record.__EDITABLE__) {
    return (
      <span>
        <RollbackOutlined
          title='还原'
          onClick={() => handleEdit(false)}
          className='fz-18 color-link mg-r12'
        />
        <CheckSquareOutlined
          title='确定'
          onClick={() => handleEdit(true, true)}
          className='fz-18 color-link'
        />
      </span>
    )
  }
  return (
    <span onClick={() => handleEdit(true)}>
      <EasyIcon type={ICON} defaultIcon='EditOutlined' className='fz-16' />
      <span title={LABEL} className='pd-l4'>{LABEL}</span>
    </span>
  )
}

export default TableRowEdit